import { Subject } from "rxjs/Subject";
import { PruHttpService } from "./pru-http.service";
import { GenericService } from "./generic.service";
import { AggregationService } from "./aggregation.service";
import * as i0 from "@angular/core";
import * as i1 from "./pru-http.service";
import * as i2 from "./generic.service";
import * as i3 from "./aggregation.service";
var ExternalAccountsService = /** @class */ (function () {
    function ExternalAccountsService(_pruHttpService, _genericService, _aggService) {
        this._pruHttpService = _pruHttpService;
        this._genericService = _genericService;
        this._aggService = _aggService;
        this.extAggSubject = new Subject();
        this.extAgg$ = this.extAggSubject.asObservable();
    }
    //getExtAccountsData(indicator?: any): any {
    ExternalAccountsService.prototype.getExtAccountsData = function () {
        var _this = this;
        var externalAccountsByCategory = null, prodTitles = null;
        this._genericService.spinner = true;
        var aggExtUrl = "/api/co/secure/myaccounts/v2/accountsummary?buName=AGG&clearcache=" +
            this._genericService.xPruId;
        // if (/localhost/i.test(helpers.getCurrentHost())) aggExtUrl = '/aggData1';
        this._pruHttpService.get(aggExtUrl, "AggregatedService").subscribe(function (res) {
            if (res &&
                res.contractSummaryResponse &&
                res.contractSummaryResponse.contractSummary) {
                if (res.contractSummaryResponse.contractSummary.length > 0) {
                    prodTitles = [
                        "bank",
                        "investments",
                        "insurance",
                        "debt",
                        "other",
                        "focusArr"
                    ];
                    externalAccountsByCategory = {}; //{'Cash':[], 'Investments':[], 'Insurance':[], 'Debt':[], 'Other':[]};
                    prodTitles.forEach(function (element, index) {
                        externalAccountsByCategory[prodTitles[index]] = [];
                    });
                    res.contractSummaryResponse.contractSummary.forEach(function (element) {
                        externalAccountsByCategory.focusArr.push(element.providerAccountID + element.contractID);
                        element.productTitle = element.productTitle
                            ? element.productTitle
                            : "N/A";
                        element.lineOfBusiness = element.lineOfBusiness
                            ? element.lineOfBusiness
                            : element.productTitle;
                        element.accountType = "external account";
                        if (element &&
                            (element.productCategory.toLowerCase() === "cash" ||
                                element.productCategory.toLowerCase() === "bank")) {
                            externalAccountsByCategory.bank.push(element);
                        }
                        else if (element &&
                            element.productCategory.toLowerCase() === "investment") {
                            externalAccountsByCategory.investments.push(element);
                        }
                        else if (element &&
                            element.productCategory.toLowerCase() === "insurance") {
                            externalAccountsByCategory.insurance.push(element);
                        }
                        else if (element &&
                            (element.productCategory.toLowerCase() === "creditcard" ||
                                element.productCategory.toLowerCase() === "loan")) {
                            externalAccountsByCategory.debt.push(element);
                        }
                        else if (element) {
                            externalAccountsByCategory.other.push(element);
                        }
                    });
                    _this._genericService.addAggData(res["contractSummaryResponse"]);
                    _this.extAggSubject.next(externalAccountsByCategory);
                }
                else {
                    externalAccountsByCategory = [];
                    _this.handleErrorExtAccountsData("empty");
                }
            }
            else {
                externalAccountsByCategory = null;
                _this.handleErrorExtAccountsData("error");
            }
        }, function (error) {
            externalAccountsByCategory = null;
            _this.handleErrorExtAccountsData("error");
        });
    };
    ExternalAccountsService.prototype.handleErrorExtAccountsData = function (eve_type) {
        this._genericService.addAggData({
            contractSummary: [],
            responseCode: "200"
        });
        this.extAggSubject.next(eve_type);
    };
    ExternalAccountsService.ngInjectableDef = i0.defineInjectable({ factory: function ExternalAccountsService_Factory() { return new ExternalAccountsService(i0.inject(i1.PruHttpService), i0.inject(i2.GenericService), i0.inject(i3.AggregationService)); }, token: ExternalAccountsService, providedIn: "root" });
    return ExternalAccountsService;
}());
export { ExternalAccountsService };
